import { useAnalyticsMetaData } from '@/hooks/AnalyticsMetaDataHook'
import { Thumbnail, Title, Wrapper } from './CategoryPill.styles'

const CategoryPill: React.FC<{ image: string; name: string; url: string }> = ({ name, image, url }) => {
  const metadata = useAnalyticsMetaData()

  const hanldeCategoryClick = () => {
    metadata.setIsPopularCategory(true)
  }
  return (
    <Wrapper href={url} data-testid={`cat-pill-${url}`} onClick={() => hanldeCategoryClick()}>
      <Thumbnail image={image && image} />
      <Title>{name}</Title>
    </Wrapper>
  )
}

export default CategoryPill
